// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"147":"inventario","443":"about","550":"pedidos","919":"pedidoRealizado"}[chunkId] + "." + {"147":"49af295a","443":"bd2caa49","550":"5d3d2edc","919":"9629309f"}[chunkId] + ".js";
};